import media from '@/ui/media'
import styled from 'styled-components'
import BookingStatisticsIcon from './BookingStatisticsIcon'

const BookingStatistics = () => {
  return (
    <BookingStatisticsWrapper>
      <BookingStatisticsButton aria-label="Статистика">
        <BookingStatisticsIcon />
      </BookingStatisticsButton>
    </BookingStatisticsWrapper>
  )
}

const BookingStatisticsWrapper = styled.div`
  position: fixed;
  bottom: calc(2rem + 64px + 16px);
  right: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${media.lg`
    bottom: calc(10rem + 64px + 16px);
  `}
`

const BookingStatisticsButton = styled.div`
  cursor: pointer;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--text-accent);
  background: var(--accent);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
`

export default BookingStatistics
